<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_brand') || '品牌名称'"
            prop="brandCode"
          >
            <dict-select
              v-model="formData.brandCode"
              :selectedLabel.sync="formData.brandName"
              :placeholder="$l('form_placeholder_brand') || '请选择品牌'"
              url="/digitalCenter/masterbrand/masterBrandSelect"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    custBrandCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        brandCode: [
          {
            required: true,
            message: this.$l('form_placeholder_brand') || '请选择品牌',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custBrandCode) return
      const res = await this.$api
        .masterCustomerBrandDetailApi({ custBrandCode: this.custBrandCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBrandSaveApi({
          ...this.formData,
          custCode: this.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
